import { getItemReturnWindow } from '../order-details/LineItemUtils';
import { STATUS_DESCRIPTION } from '../../constants/status';
import { retrieveTrackingNumbers } from '../returns/returns-helper';
import { isReturnOrderAPickUp } from '../order-details/OrderDetailsUtils';
import { dateFormat } from '../../components/order-details/util/format';
import { longWeekDayMonthDay, monthDay, weekDayMonthDay, } from '../../constants/dateStrings';
var ONLINE = 'ONLINE';
var INSTORE = 'INSTORE';
export var getOrderType = function (orderNumber) {
    if (orderNumber &&
        ((orderNumber === null || orderNumber === void 0 ? void 0 : orderNumber[0]) === 'W' ||
            (orderNumber === null || orderNumber === void 0 ? void 0 : orderNumber[0]) === 'C' ||
            (orderNumber === null || orderNumber === void 0 ? void 0 : orderNumber[0]) === 'H')) {
        return ONLINE;
    }
    return INSTORE;
};
// UNUSED FOR NOW, SWITCHED TO dateFormat
export var formatDateRange = function (date, monthLength, weekdayLength) {
    var _a;
    try {
        var newDate = typeof date === 'string'
            ? new Date((_a = date === null || date === void 0 ? void 0 : date.split('T')) === null || _a === void 0 ? void 0 : _a[0])
            : new Date(date);
        var dateStrings = newDate
            .toLocaleDateString('en-US', {
            year: 'numeric',
            month: monthLength,
            day: 'numeric',
            timeZone: 'UTC',
        })
            .split(',');
        if (weekdayLength === undefined)
            return dateStrings[0];
        return "".concat(dateStrings[0], ", ").concat(dateStrings[1]);
    }
    catch (error) {
        return 'Date Unavailable';
    }
};
export var getDateObject = function (date) {
    var newDate = date && new Date(date);
    if (newDate && Number.isNaN(newDate.getDate())) {
        return undefined;
    }
    return newDate || undefined;
};
export var orderStatus = function (statusDescription, delivery, fulfillmentType) {
    if (fulfillmentType === 'MISC') {
        return 'Miscellaneous Item';
    }
    if (['Canceled', 'InStore', 'InStorePurchase', 'Returned'].includes(statusDescription)) {
        return {
            Canceled: 'Order Canceled',
            InStore: 'Store Purchase',
            InStorePurchase: 'Store Purchase',
            Returned: 'Order Returned',
        }[statusDescription];
    }
    if (['On Schedule', 'Being Processed'].includes(statusDescription)) {
        return 'Processing Order';
    }
    if (['BuyOnlinePickupInStore', 'BuyOnlineShipToStore'].includes(fulfillmentType)) {
        if (['Complete'].includes(statusDescription)) {
            return "Picked up on ".concat(dateFormatter(delivery, 'LL'));
        }
        return "Ready by ".concat(dateFormatter(delivery, 'LL'));
    }
    if (['ShipToHome', 'Appliance', 'BuyOnlineDeliverFromStore'].includes(fulfillmentType)) {
        if (['Complete'].includes(statusDescription)) {
            return "Delivered on ".concat(dateFormatter(delivery, 'LL'));
        }
        return "Arriving ".concat(dateFormatter(delivery, 'LL'));
    }
    return 'Status Unavailable';
};
export var currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});
export var phoneNumberFormatter = function (phone) {
    if (phone) {
        return phone.slice(0, 3) + '-' + phone.slice(3, 6) + '-' + phone.slice(6);
    }
    return null;
};
export var dateFormatter = function (date, format) {
    if (format === void 0) { format = 'L'; }
    if (date === null || date === undefined) {
        return 'date unavailable';
    }
    var timezoneDate;
    if (/[T]/.test(date)) {
        timezoneDate = date.split('T')[0];
    }
    var splitDate;
    if (timezoneDate) {
        splitDate = timezoneDate.split('-');
    }
    else if (['/'].includes(date)) {
        splitDate = date.split('/');
    }
    else {
        splitDate = date.split('-');
    }
    var newDate;
    var month;
    var day;
    switch (format) {
        case 'L':
            return "".concat(splitDate[1], "/").concat(splitDate[2], "/").concat(splitDate[0]);
        case 'l':
            if (splitDate[1][0] === '0') {
                month = splitDate[1][1];
            }
            else {
                month = splitDate[1];
            }
            if (splitDate[2][0] === '0') {
                day = splitDate[2][1];
            }
            else {
                day = splitDate[2];
            }
            return "".concat(month, "/").concat(day, "/").concat(splitDate[0]);
        case 'LL':
        case 'll':
            newDate = new Date(Number(splitDate[0]), Number(splitDate[1]) - 1, Number(splitDate[2]))
                .toLocaleDateString('en-US', {
                weekday: 'short',
                year: 'numeric',
                month: format === 'LL' ? 'long' : 'short',
                day: 'numeric',
            })
                .split(',');
            return "".concat(newDate[1], ", ").concat(newDate[2]);
        case 'LS':
        case 'ls':
            newDate = new Date(Number(splitDate[0]), Number(splitDate[1]) - 1, Number(splitDate[2])).toLocaleDateString('en-US', {
                weekday: format === 'LS' ? 'long' : 'short',
                year: undefined,
                month: format === 'LS' ? 'long' : 'short',
                day: 'numeric',
            });
            return newDate;
        case 'LLL':
        case 'lll':
            newDate = new Date(Number(splitDate[0]), Number(splitDate[1]) - 1, Number(splitDate[2])).toLocaleDateString('en-US', {
                weekday: format === 'LLL' ? 'long' : 'short',
                year: 'numeric',
                month: format === 'LLL' ? 'long' : 'short',
                day: 'numeric',
            });
            return newDate;
        default:
            return 'Unknown date format';
    }
};
export var statusStepperData = function (record, status, fulfillmentType, isInstore) {
    var _a, _b, _c;
    if (status === void 0) { status = 'statusDescription'; }
    var statusDescription;
    if (record && 'statusDescription' in record) {
        // Type assertion
        statusDescription = record.statusDescription;
    }
    if (statusDescription === 'ReturnInProgress') {
        statusDescription = 'Return In Progress';
    }
    if (['ShipToHome'].includes(fulfillmentType !== null && fulfillmentType !== void 0 ? fulfillmentType : '')) {
        return {
            statusDescription: statusDescription,
            title: 'Delivery',
            type: 'STH',
        }[status];
    }
    if (['BuyOnlineShipToStore'].includes(fulfillmentType !== null && fulfillmentType !== void 0 ? fulfillmentType : '')) {
        return {
            statusDescription: statusDescription,
            title: 'Pickup',
            type: 'BOSS',
        }[status];
    }
    if (['BuyOnlineDeliverFromStore', 'DeliverFromStore'].includes(fulfillmentType !== null && fulfillmentType !== void 0 ? fulfillmentType : '')) {
        return {
            statusDescription: statusDescription,
            title: 'Delivery',
            type: 'BODFS',
        }[status];
    }
    if (['BuyOnlinePickupInStore', 'WillCallFulfillment'].includes(fulfillmentType !== null && fulfillmentType !== void 0 ? fulfillmentType : '')) {
        return {
            statusDescription: statusDescription,
            title: 'Pickup',
            type: 'BOPIS',
        }[status];
    }
    if (['Appliance'].includes(fulfillmentType !== null && fulfillmentType !== void 0 ? fulfillmentType : '')) {
        return {
            statusDescription: statusDescription,
            title: 'Delivery',
            type: 'APPLIANCE',
        }[status];
    }
    if (['MISC'].includes(fulfillmentType !== null && fulfillmentType !== void 0 ? fulfillmentType : '')) {
        return {
            statusDescription: 'unavailable',
            title: 'Miscellaneous',
            type: 'MISC',
        }[status];
    }
    if (isInstore ||
        ['InStorePurchase', 'InStore'].includes(fulfillmentType !== null && fulfillmentType !== void 0 ? fulfillmentType : '')) {
        return {
            title: 'In-Store Purchase',
            expandedTitle: "Purchased ".concat(dateFormat((_c = (_b = (_a = record === null || record === void 0 ? void 0 : record.lineItems) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.salesDate) !== null && _c !== void 0 ? _c : '', weekDayMonthDay)),
            statusDescription: statusDescription,
        }[status];
    }
    if (['unavailable'].includes(fulfillmentType !== null && fulfillmentType !== void 0 ? fulfillmentType : '')) {
        return {
            statusDescription: 'unavailable',
            title: 'Unavailable',
            type: 'STH',
        }[status];
    }
    if (['CanceledItems'].includes(fulfillmentType !== null && fulfillmentType !== void 0 ? fulfillmentType : '')) {
        return {
            statusDescription: 'canceled',
            title: 'Canceled Items',
            type: 'CanceledItems',
        }[status];
    }
    if (['Additional Items'].includes(fulfillmentType !== null && fulfillmentType !== void 0 ? fulfillmentType : '')) {
        return {
            title: 'Additional Items',
            type: 'Additional Items',
        }[status];
    }
};
export var returnDatePurchaseHistoryText = function (fg) {
    var _a;
    var firstItem = (_a = fg === null || fg === void 0 ? void 0 : fg.lineItems) === null || _a === void 0 ? void 0 : _a[0];
    var isSoris = fg === null || fg === void 0 ? void 0 : fg.isSoris;
    var date = (firstItem === null || firstItem === void 0 ? void 0 : firstItem.statusUpdatedDate) || '';
    if ((firstItem === null || firstItem === void 0 ? void 0 : firstItem.statusDescription) === STATUS_DESCRIPTION.RETURN_INITIATED) {
        // Pickup returns should not show "Return by"
        var trackingNumbers = retrieveTrackingNumbers(fg);
        var isReturnPickUp = isReturnOrderAPickUp(trackingNumbers, firstItem === null || firstItem === void 0 ? void 0 : firstItem.isJobSitePickup);
        if (isReturnPickUp)
            return 'Return Pickup Requested';
        var returnWindow = (firstItem === null || firstItem === void 0 ? void 0 : firstItem.returnByDate) || '';
        if (isSoris && returnWindow && returnWindow !== 'EXPIRED') {
            return 'Return in-store by ' + dateFormat(returnWindow, weekDayMonthDay);
        }
        if (!isSoris && returnWindow && returnWindow !== 'EXPIRED') {
            return 'Return to UPS by ' + dateFormat(returnWindow, weekDayMonthDay);
        }
        return 'Return Initiated ' + dateFormat(date, weekDayMonthDay, true);
    }
    if ((firstItem === null || firstItem === void 0 ? void 0 : firstItem.statusDescription) === STATUS_DESCRIPTION.RETURN_IN_PROGRESS) {
        return 'Received by UPS ' + dateFormat(date, monthDay, true);
    }
    return 'Return Completed ' + dateFormat(date, monthDay, true);
};
// Only used in the Interim Purchase History layout. TO BE DELETED AT SOME POINT
export var returnDateInterimPurchaseHistoryText = function (fg) {
    var _a;
    var firstItem = (_a = fg === null || fg === void 0 ? void 0 : fg.lineItems) === null || _a === void 0 ? void 0 : _a[0];
    var isSoris = fg === null || fg === void 0 ? void 0 : fg.isSoris;
    var date = (firstItem === null || firstItem === void 0 ? void 0 : firstItem.statusUpdatedDate) || '';
    if ((firstItem === null || firstItem === void 0 ? void 0 : firstItem.statusDescription) === STATUS_DESCRIPTION.RETURN_INITIATED) {
        // Pickup returns should not show "Return by"
        var trackingNumbers = retrieveTrackingNumbers(fg);
        var isReturnPickUp = isReturnOrderAPickUp(trackingNumbers, firstItem === null || firstItem === void 0 ? void 0 : firstItem.isJobSitePickup);
        if (isReturnPickUp)
            return 'Return Pickup Requested';
        var returnWindow = (firstItem === null || firstItem === void 0 ? void 0 : firstItem.returnByDate) || '';
        if (isSoris && returnWindow && returnWindow !== 'EXPIRED') {
            return 'Return in-store by ' + dateFormat(returnWindow, weekDayMonthDay);
        }
        if (!isSoris && returnWindow && returnWindow !== 'EXPIRED') {
            return 'Return to UPS by ' + dateFormat(returnWindow, weekDayMonthDay);
        }
        return 'Initiated ' + dateFormat(date, weekDayMonthDay, true);
    }
    if ((firstItem === null || firstItem === void 0 ? void 0 : firstItem.statusDescription) === STATUS_DESCRIPTION.RETURN_IN_PROGRESS) {
        return 'Received by UPS ' + dateFormat(date, monthDay, true);
    }
    return 'Completed ' + dateFormat(date, monthDay, true);
};
export var returnDateOrderDetailsText = function (fg) {
    var _a;
    var firstItem = (_a = fg === null || fg === void 0 ? void 0 : fg.lineItems) === null || _a === void 0 ? void 0 : _a[0];
    var isSoris = Boolean(fg === null || fg === void 0 ? void 0 : fg.isSoris);
    var date = (firstItem === null || firstItem === void 0 ? void 0 : firstItem.statusUpdatedDate) || '';
    if ((firstItem === null || firstItem === void 0 ? void 0 : firstItem.statusDescription) === STATUS_DESCRIPTION.RETURN_INITIATED) {
        var trackingNumbers = retrieveTrackingNumbers(fg);
        var isReturnPickUp = isReturnOrderAPickUp(trackingNumbers, firstItem === null || firstItem === void 0 ? void 0 : firstItem.isJobSitePickup);
        if (isReturnPickUp)
            return 'Return Pickup Requested';
        var returnWindow = (firstItem === null || firstItem === void 0 ? void 0 : firstItem.returnByDate) || '';
        if (isSoris && returnWindow && returnWindow !== 'EXPIRED') {
            return ('Return in-store by ' + dateFormat(returnWindow, longWeekDayMonthDay));
        }
        if (!isSoris) {
            // Display return by window once UPS barcode is enabled
            var deliveryStatusCode = firstItem.statusCode;
            var returnByDate = firstItem.returnByDate, returnWindowEndDate = firstItem.returnWindowEndDate;
            var returnTrackingList = firstItem.returnOrderTrackingInfo;
            return getItemReturnWindow(deliveryStatusCode, returnWindowEndDate, returnByDate, returnTrackingList, isSoris);
        }
        return 'Initiated ' + dateFormat(date, longWeekDayMonthDay, true);
    }
    if ((firstItem === null || firstItem === void 0 ? void 0 : firstItem.statusDescription) === STATUS_DESCRIPTION.RETURN_IN_PROGRESS) {
        return 'Received by UPS ' + dateFormat(date, monthDay, true);
    }
    return 'Completed ' + dateFormat(date, monthDay, true);
};
